module.exports = __webpack_public_path__ + "static/media/linkedIn-logo.f08c524d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/linkedIn-logo.png
// module id = 83
// module chunks = 0